export function readablePhoneNumber(phoneNumber?: string | number): string {
    if (!phoneNumber) {
        return "";
    }

    let phoneNumberHumanReadable = String(phoneNumber);
    const m = phoneNumberHumanReadable.match(/^(\+\d+)(\d{3})(\d{3})(\d{3})$/);

    if (m) {
        phoneNumberHumanReadable = `${m[1]} ${m[2]} ${m[3]} ${m[4]}`;
    }

    return phoneNumberHumanReadable;
}
